const openBtn = document.getElementById('open-menu');
const closeBtn = document.getElementById('close-menu');
const mobileMenu = document.getElementById('mobile-menu');

// Open menu
openBtn.addEventListener('click', () => {
  mobileMenu.classList.remove('hidden');
  openBtn.classList.add('hidden');
  closeBtn.classList.remove('hidden');
});

// Close menu
closeBtn.addEventListener('click', () => {
  mobileMenu.classList.add('hidden');
  closeBtn.classList.add('hidden');
  openBtn.classList.remove('hidden');
});